export const megaSaleABI = [
    {
        type: "constructor",
        inputs: [
            {
                name: "init",
                type: "tuple",
                internalType: "struct MegaSale.Init",
                components: [
                    {
                        name: "saleUUID",
                        type: "bytes16",
                        internalType: "bytes16",
                    },
                    {
                        name: "admin",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "usdt",
                        type: "address",
                        internalType: "contract IERC20Metadata",
                    },
                    {
                        name: "purchasePermitSigner",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "proceedsReceiver",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "pauser",
                        type: "address",
                        internalType: "address",
                    },
                ],
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "DEFAULT_ADMIN_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "PAUSER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "PURCHASE_PERMIT_SIGNER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "REFUNDER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "SALE_MANAGER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "SETTLER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "TOKEN_RECOVERER_ROLE",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "auctionInactivityDuration",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "cancelBid",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "closeAuctionAtTimestamp",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "entitiesByAddress",
        inputs: [
            {
                name: "addrs",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes16[]",
                internalType: "bytes16[]",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "entitiesIn",
        inputs: [
            {
                name: "from",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "to",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes16[]",
                internalType: "bytes16[]",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "entityAt",
        inputs: [
            {
                name: "index",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "entityByAddress",
        inputs: [
            {
                name: "addr",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "entityStateByID",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple",
                internalType: "struct MegaSale.EntityState",
                components: [
                    {
                        name: "addr",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "entityID",
                        type: "bytes16",
                        internalType: "bytes16",
                    },
                    {
                        name: "allocatedAmount",
                        type: "uint64",
                        internalType: "uint64",
                    },
                    {
                        name: "refunded",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "cancelled",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "activeBid",
                        type: "tuple",
                        internalType: "struct MegaSale.Bid",
                        components: [
                            {
                                name: "price",
                                type: "uint64",
                                internalType: "uint64",
                            },
                            {
                                name: "amount",
                                type: "uint64",
                                internalType: "uint64",
                            },
                            {
                                name: "lockup",
                                type: "bool",
                                internalType: "bool",
                            },
                        ],
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "entityStatesByID",
        inputs: [
            {
                name: "entityIDs",
                type: "bytes16[]",
                internalType: "bytes16[]",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple[]",
                internalType: "struct MegaSale.EntityState[]",
                components: [
                    {
                        name: "addr",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "entityID",
                        type: "bytes16",
                        internalType: "bytes16",
                    },
                    {
                        name: "allocatedAmount",
                        type: "uint64",
                        internalType: "uint64",
                    },
                    {
                        name: "refunded",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "cancelled",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "activeBid",
                        type: "tuple",
                        internalType: "struct MegaSale.Bid",
                        components: [
                            {
                                name: "price",
                                type: "uint64",
                                internalType: "uint64",
                            },
                            {
                                name: "amount",
                                type: "uint64",
                                internalType: "uint64",
                            },
                            {
                                name: "lockup",
                                type: "bool",
                                internalType: "bool",
                            },
                        ],
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "entityStatesIn",
        inputs: [
            {
                name: "from",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "to",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple[]",
                internalType: "struct MegaSale.EntityState[]",
                components: [
                    {
                        name: "addr",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "entityID",
                        type: "bytes16",
                        internalType: "bytes16",
                    },
                    {
                        name: "allocatedAmount",
                        type: "uint64",
                        internalType: "uint64",
                    },
                    {
                        name: "refunded",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "cancelled",
                        type: "bool",
                        internalType: "bool",
                    },
                    {
                        name: "activeBid",
                        type: "tuple",
                        internalType: "struct MegaSale.Bid",
                        components: [
                            {
                                name: "price",
                                type: "uint64",
                                internalType: "uint64",
                            },
                            {
                                name: "amount",
                                type: "uint64",
                                internalType: "uint64",
                            },
                            {
                                name: "lockup",
                                type: "bool",
                                internalType: "bool",
                            },
                        ],
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "finalizeSettlement",
        inputs: [
            {
                name: "expectedTotalAllocatedUSDT",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "getRoleAdmin",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getRoleMember",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "index",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getRoleMemberCount",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getRoleMembers",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        outputs: [
            {
                name: "",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "grantRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "hasRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "lastBidTimestamp",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "manualStage",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8",
                internalType: "enum MegaSale.Stage",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "nonWinnerPriceThreshold",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "numEntities",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "openAuction",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "openCancellation",
        inputs: [
            {
                name: "nonWinnerPriceThresholdInTicks",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "openSettlement",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "pause",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "paused",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "proceedsReceiver",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "processRefunds",
        inputs: [
            {
                name: "entityIDs",
                type: "bytes16[]",
                internalType: "bytes16[]",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "recoverTokens",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "contract IERC20",
            },
            {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "renounceRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "callerConfirmation",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "replaceBidWithApproval",
        inputs: [
            {
                name: "bid",
                type: "tuple",
                internalType: "struct MegaSale.Bid",
                components: [
                    {
                        name: "price",
                        type: "uint64",
                        internalType: "uint64",
                    },
                    {
                        name: "amount",
                        type: "uint64",
                        internalType: "uint64",
                    },
                    {
                        name: "lockup",
                        type: "bool",
                        internalType: "bool",
                    },
                ],
            },
            {
                name: "purchasePermit",
                type: "tuple",
                internalType: "struct PurchasePermitWithAllocation",
                components: [
                    {
                        name: "permit",
                        type: "tuple",
                        internalType: "struct PurchasePermit",
                        components: [
                            {
                                name: "entityID",
                                type: "bytes16",
                                internalType: "bytes16",
                            },
                            {
                                name: "saleUUID",
                                type: "bytes16",
                                internalType: "bytes16",
                            },
                            {
                                name: "wallet",
                                type: "address",
                                internalType: "address",
                            },
                            {
                                name: "expiresAt",
                                type: "uint64",
                                internalType: "uint64",
                            },
                            {
                                name: "payload",
                                type: "bytes",
                                internalType: "bytes",
                            },
                        ],
                    },
                    {
                        name: "reservedAmount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "minAmount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "maxAmount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
            {
                name: "purchasePermitSignature",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "resetLastBidTimestamp",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "revokeRole",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "saleUUID",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "setAllocations",
        inputs: [
            {
                name: "allocations",
                type: "tuple[]",
                internalType: "struct MegaSale.Allocation[]",
                components: [
                    {
                        name: "entityID",
                        type: "bytes16",
                        internalType: "bytes16",
                    },
                    {
                        name: "amountUSDT",
                        type: "uint64",
                        internalType: "uint64",
                    },
                ],
            },
            {
                name: "allowOverwrite",
                type: "bool",
                internalType: "bool",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setAuctionInactivityWindow",
        inputs: [
            {
                name: "window",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setCloseAuctionAtTimestamp",
        inputs: [
            {
                name: "timestamp",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setManualStage",
        inputs: [
            {
                name: "s",
                type: "uint8",
                internalType: "enum MegaSale.Stage",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setPaused",
        inputs: [
            {
                name: "isPaused",
                type: "bool",
                internalType: "bool",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setProceedsReceiver",
        inputs: [
            {
                name: "newproceedsReceiver",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "stage",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8",
                internalType: "enum MegaSale.Stage",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "supportsInterface",
        inputs: [
            {
                name: "interfaceId",
                type: "bytes4",
                internalType: "bytes4",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "totalActiveBidAmount",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "totalAllocatedUSDT",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "totalRefundedAmount",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint64",
                internalType: "uint64",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "usdt",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IERC20Metadata",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "withdraw",
        inputs: [],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "withdrawn",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "event",
        name: "AllocationSet",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                indexed: true,
                internalType: "bytes16",
            },
            {
                name: "allocatedAmountUSDT",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "BidCancelled",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                indexed: true,
                internalType: "bytes16",
            },
            {
                name: "addr",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "BidPlaced",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                indexed: true,
                internalType: "bytes16",
            },
            {
                name: "bid",
                type: "tuple",
                indexed: false,
                internalType: "struct MegaSale.Bid",
                components: [
                    {
                        name: "price",
                        type: "uint64",
                        internalType: "uint64",
                    },
                    {
                        name: "amount",
                        type: "uint64",
                        internalType: "uint64",
                    },
                    {
                        name: "lockup",
                        type: "bool",
                        internalType: "bool",
                    },
                ],
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "DepositPlaced",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                indexed: true,
                internalType: "bytes16",
            },
            {
                name: "amount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "EntityInitialized",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                indexed: true,
                internalType: "bytes16",
            },
            {
                name: "addr",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "Refunded",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                indexed: true,
                internalType: "bytes16",
            },
            {
                name: "addr",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "amount",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoleAdminChanged",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "previousAdminRole",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "newAdminRole",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoleGranted",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "sender",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoleRevoked",
        inputs: [
            {
                name: "role",
                type: "bytes32",
                indexed: true,
                internalType: "bytes32",
            },
            {
                name: "account",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "sender",
                type: "address",
                indexed: true,
                internalType: "address",
            },
        ],
        anonymous: false,
    },
    {
        type: "error",
        name: "AccessControlBadConfirmation",
        inputs: [],
    },
    {
        type: "error",
        name: "AccessControlUnauthorizedAccount",
        inputs: [
            {
                name: "account",
                type: "address",
                internalType: "address",
            },
            {
                name: "neededRole",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
    },
    {
        type: "error",
        name: "AddressTiedToAnotherEntity",
        inputs: [
            {
                name: "got",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "existing",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "addr",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "AllocationAlreadySet",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "allocatedAmount",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "AllocationExceedsCommitment",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "allocation",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "commitment",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "AlreadyRefunded",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
    },
    {
        type: "error",
        name: "AlreadyWithdrawn",
        inputs: [],
    },
    {
        type: "error",
        name: "BidAlreadyCancelled",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
    },
    {
        type: "error",
        name: "BidAmountCannotBeLowered",
        inputs: [
            {
                name: "newAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "previousAmount",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "BidBelowMinAmount",
        inputs: [
            {
                name: "newBidAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "minAmount",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "BidExceedsMaxAmount",
        inputs: [
            {
                name: "newBidAmount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "maxAmount",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "BidHasAllocatedAmount",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "allocatedAmount",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "BidIsNonWinner",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "bidPrice",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "nonWinnerPriceThreshold",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "BidIsPotentialWinner",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "bidPrice",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "nonWinnerPriceThreshold",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "BidLockupCannotBeUndone",
        inputs: [],
    },
    {
        type: "error",
        name: "BidMustHaveLockup",
        inputs: [],
    },
    {
        type: "error",
        name: "BidPriceCannotBeLowered",
        inputs: [
            {
                name: "newPrice",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "previousPrice",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "BidPriceExceedsMaxPrice",
        inputs: [
            {
                name: "bidPrice",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "maxPrice",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "ECDSAInvalidSignature",
        inputs: [],
    },
    {
        type: "error",
        name: "ECDSAInvalidSignatureLength",
        inputs: [
            {
                name: "length",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "ECDSAInvalidSignatureS",
        inputs: [
            {
                name: "s",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
    },
    {
        type: "error",
        name: "EntityTiedToAnotherAddress",
        inputs: [
            {
                name: "got",
                type: "address",
                internalType: "address",
            },
            {
                name: "existing",
                type: "address",
                internalType: "address",
            },
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
    },
    {
        type: "error",
        name: "EntityWithoutBid",
        inputs: [
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidSaleUUID",
        inputs: [
            {
                name: "got",
                type: "bytes16",
                internalType: "bytes16",
            },
            {
                name: "want",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidSender",
        inputs: [
            {
                name: "got",
                type: "address",
                internalType: "address",
            },
            {
                name: "want",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "InvalidStage",
        inputs: [
            {
                name: "",
                type: "uint8",
                internalType: "enum MegaSale.Stage",
            },
        ],
    },
    {
        type: "error",
        name: "PurchasePermitExpired",
        inputs: [],
    },
    {
        type: "error",
        name: "SafeERC20FailedOperation",
        inputs: [
            {
                name: "token",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "SalePaused",
        inputs: [],
    },
    {
        type: "error",
        name: "SenderDoesNotOwnEntity",
        inputs: [
            {
                name: "sender",
                type: "address",
                internalType: "address",
            },
            {
                name: "entityID",
                type: "bytes16",
                internalType: "bytes16",
            },
        ],
    },
    {
        type: "error",
        name: "SenderWithoutRegisteredEntity",
        inputs: [
            {
                name: "addr",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "UnauthorizedSigner",
        inputs: [
            {
                name: "signer",
                type: "address",
                internalType: "address",
            },
        ],
    },
    {
        type: "error",
        name: "UnexpectedTotalAllocatedUSDT",
        inputs: [
            {
                name: "expected",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "actual",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "ZeroAddress",
        inputs: [],
    },
    {
        type: "error",
        name: "ZeroAmount",
        inputs: [],
    },
    {
        type: "error",
        name: "ZeroEntityID",
        inputs: [],
    },
    {
        type: "error",
        name: "ZeroPrice",
        inputs: [],
    },
] as const;
